

/// <reference path="TimeRangePresetConfiguration.ts" />

// Generated class DeliveryTimeRangePresetConfiguration_ManagedObject

class DeliveryTimeRangePresetConfiguration_ManagedObject extends TimeRangePresetConfiguration
{
}
